import { render } from "./application.vue?vue&type=template&id=641f96b6&scoped=true"
import script from "./application.vue?vue&type=script&lang=js"
export * from "./application.vue?vue&type=script&lang=js"

import "./application.vue?vue&type=style&index=0&id=641f96b6&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641f96b6"]])

export default __exports__